<template>
  <a
      :href="merchantOrderLine.product_url"
      target="_blank"
      rel="noopener noreferrer"
      :class="{link : newLink}"
      @click="clickHandler"
  >#{{ merchantOrderLine.sku }}
  </a>

</template>
<script>
export default {
  name: 'note-url',
  props: {
    merchantOrderLine: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      newLink: true,
    };
  },
  methods: {
    clickHandler () {
      this.$events.$emit(this.$events.URL_CLICK, { toURL: this.merchantOrderLine.product_url });
      this.newLink = false;
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  a {
    text-decoration: underline;
  }
  .LINK {
    color:#3E7697;
  }
</style>
